import { Component, OnInit } from '@angular/core';
import { SendPaymentInstructionModelService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.model.service';

@Component({
  selector: 'np-drawdown-summary',
  templateUrl: './drawdown-summary.component.html',
  styleUrls: ['./drawdown-summary.component.scss']
})
export class DrawdownSummaryComponent implements OnInit {
  tradeDrawdownCurrent = null;
  tradeDrawdown = [];
  drawdownTab = 0;
  constructor(
    public paymentModel: SendPaymentInstructionModelService
  ) { }

  ngOnInit(): void {
    this.tradeDrawdown = this.paymentModel.tradeDrawdown;
    this.tradeDrawdownCurrent = this.tradeDrawdown[0];
  }

  nextTabDrawdown() {
    this.drawdownTab++;
    if (this.drawdownTab < this.tradeDrawdown.length) {
      this.tradeDrawdownCurrent = this.tradeDrawdown[this.drawdownTab];
    } else {
      this.paymentModel.step = this.paymentModel.sendPaymentStep.paymentConfirmation;
    }
  }

  backTabDrawdown() {
    this.drawdownTab--;
    if (this.drawdownTab >= 0) {
      this.tradeDrawdownCurrent = this.tradeDrawdown[this.drawdownTab];
    } else {
      this.paymentModel.step = this.paymentModel.sendPaymentStep.balanceTradeAvailable;
    }
  }
}
